module.exports = __webpack_public_path__ + "static/adidas-affissione-80cc3c6131ff274f2947da9f361dc09c.jpg";